<div class="page">
  <span class="eyebrow">Vårt sortiment</span>
  <h1>Däck</h1>

  <div class="panel intro-card">
    <p>I vårt breda däcksortiment hittar du definitivt det du vill ha!</p>
    <p>Vi hjälper dig hitta rätt i däckdjungeln, vi har däck &amp; fälgar i alla prisklasser och för alla tillfällen.</p>
    <p>Hör av dig till oss så hjälper vi dig!</p>
  </div>

  @if (images) {
    <div class="panel carousel-card">
      <ngb-carousel [interval]="4000" [showNavigationArrows]="showNavigationArrows" [showNavigationIndicators]="showNavigationIndicators">
        @for (image of images; track image) {
          <ng-template ngbSlide>
            <div class="picsum-img-wrapper" [style.background-image]="'url(' + image + ')'">
              <img [src]="image" alt="Däckmärke">
            </div>
          </ng-template>
        }
      </ngb-carousel>
    </div>
  }
</div>
